<template>
  <v-card>
    <v-card-title class="grey lighten-2 d-flex justify-center align-center">
      <p><strong>Escolha sua localização</strong></p>
    </v-card-title>
    <v-card-subtitle class="mt-3 mb-0" style="margin-bottom: -30px!important;">
      <strong><i>Para navegar corretamente dentro da Loja Imprimax é obrigatório inserir seu CEP afim de proporcionarmos
        uma experiência personalizada</i>.</strong>
    </v-card-subtitle>
    <v-card-text>
      <label for="cep"><strong>Digite o Cep</strong></label>
      <v-text-field
          type="text"
          height="38"
          outlined
          dense
          id="cep"
          placeholder="00000-000"
          v-mask="'#####-###'"
          v-model="cep"
          hide-details
          required
      ></v-text-field>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
          elevation="0"
          width="100%"
          height="38"
          dark
          class="action-button"
          @click="searchCEP()"
          :loading="loading"
      >
        Confirmar cep
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.action-button {
  border-radius: 7.5px;
  transition: 0.3s;
  font-size: 16px !important;
  background: #bc0000 !important;
}

.action-button:hover {
  color: white !important;
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Vue from "vue";
import axios from "axios";

export default {
  name: "ConfirmExit",

  props: {
    cepProps: {
      type: String,
      default: null,
      required: false
    },
  },

  data: () => ({
    cep: null,
    fullAddress: Object,
    loading: false,
    apiService: new ApiService(),
  }),
  mounted() {
    if (this.cepProps){
      this.cep = this.cepProps;
    }
  },

  methods: {
    async searchCEP() {
      try {
        if (/^[0-9]{5}-[0-9]{3}$/.test(this.cep)) {
          this.naoLocalizado = false;
          this.location = {};
          await this.apiService
              .get(`user/postalcode?cep=${this.cep}`)
              .then(async (response) => {
                response = JSON.parse(response)
                if(response.code){
                  response.cep =response.code
                }
                const {cep} = response
                this.fullAddress = response

                if (cep) {
                  await this.getLocation()
                  this.$emit("reaload");
                  return
                }
                Vue.$globalEvent.$emit("onFlashMessage", {
                  type: "error",
                  title: "",
                  message: "O Cep informado não foi encontrado.",
                  trace: null,
                });
              });
          return;
        }
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "O Cep informado não foi encontrado.",
          trace: null,
        });
      } catch (e) {

      }
    },

    async getLocation() {
      await this.apiService
          .post("Address/geocode", this.fullAddress)
          .then((response) => {
            const { content } = response || {};
            const { results } = content || {};
            const [{ geometry, place_id }] = results || [];
            const { location } = geometry || {};
            const { lat, lng } = location || {};
            const address_cep = {
              latitude: parseFloat(lat),
              longitude: parseFloat(lng),
              place_id,
              ...this.fullAddress,
            };
            localStorage.setItem('address_cep', JSON.stringify(address_cep));
          })
          .catch((erro) => {
          });
    },
    cancel() {
      this.$emit("cancel");
    },
    action() {
      this.$emit("action");
    },
  },
};
</script>
